import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../../../views/Home.vue';
import Layout from '../views/Layout.vue';
import Main from '../views/Main.vue';
import FilterList from '../views/FilterList.vue';
import Custom1 from '../views/Custom1.vue';
import Custom2 from '../views/Custom2.vue';
import Custom3 from '../views/Custom3.vue';
import Account from '../views/Account.vue';
import UserData from '../views/UserData.vue';
import CardDetail from '../views/CardDetail.vue';
import Service from '../views/Service.vue';
import DownloadZone from '../views/DownloadZone.vue';
import Bill from '../views/Bill.vue';
import DeployApp from '../views/DeployApp.vue';
import Statistics from '../views/Statistics.vue';
import CustomerService from '../views/CustomerService.vue';
import ChatService from '../views/ChatService.vue';
import store from '../../../store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    // name: 'layout',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'main',
        component: Main,
      },
      {
        path: '/popularRankings',
        name: 'popularRankings',
        component: Main,
      },
      {
        path: '/newProducts',
        name: 'newProducts',
        component: Main,
      },
      {
        path: '/filterList',
        name: 'filterList',
        component: FilterList,
        props: true,
      },
      {
        path: '/custom1',
        name: 'custom1',
        component: Custom1,
        props: true,
      },
      {
        path: '/custom2',
        name: 'custom2',
        component: Custom2,
        props: true,
      },
      {
        path: '/custom3',
        name: 'custom3',
        component: Custom3,
        props: true,
      },
    ],
  },
  {
    path: '/account',
    component: Account,
    name: 'account',
    props: true,
    children: [
      {
        path: 'signIn',
        name: 'signIn',
        component: Account,
      },
      {
        path: 'modifyPassword',
        name: 'modifyPassword',
        component: Account,
      },
      // {
      //   path: 'modifyData',
      //   name: 'modifyData',
      //   component: UserData,
      // },
      {
        path: 'firstSignIn',
        name: 'firstSignIn',
        component: Account,
      },
      {
        path: 'forgotPassword',
        name: 'forgotPassword',
        component: Account,
      },
      {
        path: 'signUp',
        name: 'signUp',
        component: Account,
        props: true,
      },
    ],
  },
  {
    path: '/account/modifyData',
    name: 'modifyData',
    component: UserData,
  },
  {
    path: '/cardDetail',
    name: 'cardDetail',
    component: CardDetail,
    props: true,
  },
  {
    path: '/serviceSite',
    name: 'serviceSite',
    component: Service,
  },
  {
    path: '/downloadZone',
    name: 'downloadZone',
    component: DownloadZone,
  },
  {
    path: '/accountingInfo',
    name: 'accountingInfo',
    component: Bill,
    meta: { requiresAuth: ['usage'] },
  },
  {
    path: '/deployApp',
    name: 'deployApp',
    component: DeployApp,
    meta: { requiresAuth: ['usage'] },
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: Statistics,
    meta: { requiresAuth: ['basicStatistics', 'basicQuery'] },
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: CustomerService,
    // meta: { requiresAuth: ['usage'] },
  },
  {
    path: '/chatService',
    name: 'chatService',
    component: ChatService,
    meta: { requiresAuth: ['usage'] },
  },
  // {
  //   path: '/account/:form?',
  //   name: 'account',
  //   component: Account,
  //   props: true,
  // },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '*',
    redirect: '/error',
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) {
    next();
    return;
  }
  const policy = store.state.authenticate.isSignIn ? Object.keys(store.state.authenticate.userAttribute.policy) : [];
  let isPermit = false;
  let permission = {};
  to.meta.requiresAuth.forEach((element) => {
    permission = store.state.dbTable.permissionList.find((x) => x.name === element);
    if (permission && policy.findIndex((x) => x === permission.id) !== -1) {
      isPermit = true;
    }
  });
  if (isPermit) {
    next();
  } else {
    next({ name: 'main' });
  }
});

export default router;
